import {Injectable} from '@angular/core';

/** One-shot flash messages for the logged-in /profile page (no URL params). */
@Injectable({providedIn: 'root'})
export class ProfileFlashService {
  private listingMessage: string | null = null;
  private listingsTab = false;

  setListingMessage(message: string, openListingsTab = true): void {
    this.listingMessage = message;
    this.listingsTab = openListingsTab;
  }

  consumeListingMessage(): string | null {
    const message = this.listingMessage;
    this.listingMessage = null;
    return message;
  }

  consumeOpenListingsTab(): boolean {
    const open = this.listingsTab;
    this.listingsTab = false;
    return open;
  }
}
